import { FirebaseTest } from "../FirebaseTest";
import { FirestoreTest } from "../FirestoreTest";
import { FirebaseStorageTest } from "../FirebaseStorageTest";
import { ReachabilityTest } from "../ReachabilityTest";
import { DailyReachabilityTest } from "../DailyReachabilityTest";

export const FirewallTest = () => (
  <>
    <FirebaseTest />
    <FirestoreTest />
    <FirebaseStorageTest />
    <DailyReachabilityTest />
    <ReachabilityTest />
  </>
);
